export enum ConsentDetailsEvents {
  ChangeAgreement = 'changeAgreement',
  ChangeCategoryExpandState = 'changeCategoryExpandState'
}

export interface ChangeAgreementEventData {
  id: string
  value: boolean
}
